export default "__VITE_ASSET__f51c2324__"